import { ref } from 'vue';
import store from '~/store';
import { defineStore } from 'pinia';
import { type UploadFile, type UploadRawFile } from 'element-plus';

export const videoStore = defineStore('video', () => {
  const videoFile = ref<UploadFile>();

  const setVideoFile = async (value: Blob | string | null) => {
    if (value instanceof Blob) {
      const file = new File([value], 'video.mp4', { type: 'video/mp4' }) as UploadRawFile;
      videoFile.value = {
        name: file.name,
        percentage: 0,
        status: 'ready',
        size: file.size,
        raw: file,
        uid: file.uid,
        url: URL.createObjectURL(file),
      };
    } else if (typeof value === 'string') {
      const file = new File([await fetch(value).then((res) => res.blob())], 'video.mp4', {
        type: 'video/mp4',
      }) as UploadRawFile;
      videoFile.value = {
        name: file.name,
        percentage: 0,
        status: 'ready',
        size: file.size,
        raw: file,
        uid: file.uid,
        url: URL.createObjectURL(file),
      };
    } else {
      videoFile.value = undefined;
    }
  };

  return { videoFile, setVideoFile };
});

/** 在 setup 外使用 */
export function useVideoStoreHook() {
  return videoStore(store);
}
